import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { ProductService } from '../../../_services/api/product.service';
import { ProductRatePlanStatus } from 'src/app/app.data';

@Component({
  selector: 'app-template-selector',
  templateUrl: './template-selector.component.html',
  styleUrls: ['./template-selector.component.scss']
})
export class TemplateSelectorComponent implements OnInit {
  @Input() hideNew = false;
  myControl = new FormControl(null);
  options: any[] = [];
  filteredOptions: Observable<any[]>;
  @Output() selectedTemplate = new EventEmitter();
  constructor(
    private productService: ProductService
  ) { }

  ngOnInit(): void {
    this.getRateplanTemplates()
  }

  private _filter(value: string): string[] {
    const filterValue = value ? value.toLowerCase() : '';
    return this.options.filter((option: any) => option.name.toLowerCase().includes(filterValue));
  }

  private getRateplanTemplates(){
    const httpParams: HttpParamsInterface = {}

    this.productService.getProductRateplanTemplates(httpParams).subscribe((res)=>{
      this.options = res.data.filter(item=>item.status == ProductRatePlanStatus.published);
      this.attachSearchListner();
    })
  }

  displayFn(template){
    return template?.name
  }

  private attachSearchListner(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  onSelectTemplate($event) {
    this.selectedTemplate.emit($event?.option?.value)
  }
}
